var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23752_28337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04077 0.0660892C4.87853 0.396089 2.053 2.47797 0.768525 5.42409C-0.0592354 7.32609 -0.196995 9.51609 0.390765 11.5322C1.11676 14.0461 2.99477 16.17 5.42477 17.2322C7.32677 18.06 9.51677 18.1977 11.533 17.61C14.5508 16.74 16.9269 14.2622 17.7069 11.184C18.9246 6.36009 15.9368 1.42773 11.1008 0.276089C10.0385 0.0240892 9.10301 -0.0420308 8.04077 0.0660892ZM8.16077 5.64009C8.92853 6.66009 9.57677 7.50009 9.60077 7.50009C9.62477 7.50009 10.423 6.66009 11.3648 5.64009L13.0868 3.78009H14.0648L13.8548 4.00233C13.7348 4.12785 12.9548 4.97397 12.1208 5.88009C11.2868 6.78609 10.4708 7.66785 10.3085 7.83009L10.0208 8.13609L12.2708 11.1301C13.5068 12.7801 14.5208 14.1478 14.5208 14.1723C14.5208 14.2023 13.783 14.2201 12.8885 14.2201L11.2508 14.2141L9.72677 12.1741C8.67677 10.7641 8.18477 10.1577 8.13677 10.1941C8.10077 10.2241 7.24853 11.1423 6.24077 12.2341L4.41077 14.2201H3.94852C3.69076 14.2201 3.48076 14.2078 3.48076 14.1901C3.48076 14.1723 4.43476 13.1278 5.59853 11.8741C6.75689 10.6201 7.71689 9.57009 7.72853 9.55233C7.73477 9.52785 6.78077 8.22609 5.61077 6.66009C4.44077 5.10009 3.48076 3.81009 3.48076 3.79785C3.48076 3.78621 4.21853 3.78009 5.12477 3.78009H6.76853L8.16077 5.64009Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96041 4.584C4.98429 4.626 6.49593 6.654 8.30817 9.07776L11.6082 13.4939L12.3459 13.5C12.802 13.5 13.0782 13.476 13.0659 13.44C13.0604 13.41 11.5543 11.3822 9.73041 8.94L6.40593 4.5H5.66217C5.04441 4.5 4.91817 4.51224 4.96041 4.584Z",
    fill: "#777081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23752_28337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c65d4fb1.svg";
export { ForwardRef as ReactComponent };